import * as React from "react";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import SportSelect from "../../SportSelect";

export default function SportPickerListItem(): React.JSX.Element {
    return (
        <ListItem
            sx={{
                py: 2,
                backgroundColor: (theme) => theme.palette.common.white,
            }}
        >
            <ListItemText>
                <SportSelect showOnlyCompatible />
            </ListItemText>
        </ListItem>
    );
}
